
import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import './ChangePassword.css';


const getInitialDarkMode = () => {
  return localStorage.getItem('darkMode') === 'true';
};


const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(getInitialDarkMode());
  const navigate = useNavigate();

  // Listen for Navbar dark mode toggle
  useEffect(() => {
    const handleDarkModeChange = () => {
      setIsDarkMode(getInitialDarkMode());
    };
    window.addEventListener('darkModeChanged', handleDarkModeChange);
    return () => {
      window.removeEventListener('darkModeChanged', handleDarkModeChange);
    };
  }, []);

  // Role check: Only allow 'user' role
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/publicuser/login', { replace: true });
      return;
    }
    try {
      const decoded = jwtDecode(token);
      if (!decoded.role || decoded.role !== 'user') {
        navigate('/publicuser/login', { replace: true });
      }
    } catch (err) {
      navigate('/publicuser/login', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    if (newPassword !== confirmPassword) {
      setMessage('New password and confirm password do not match.');
      return;
    }
    setLoading(true);
    const token = localStorage.getItem('token');
    if (!token) {
      setMessage('Session expired. Please log in again.');
      setLoading(false);
      setTimeout(() => navigate('/publicuser/login', { replace: true }), 1500);
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '/api';
      const response = await fetch(`${apiUrl}/publicuser/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          currentPassword,
          newPassword
        })
      });
      const data = await response.json();
      if (response.ok) {
        setMessage('Password changed successfully!');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setMessage(data.error || data.message || 'Failed to change password.');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className={`change-password-container${isDarkMode ? ' dark' : ''}`}> 
      <h2>Change Password</h2>
      <form onSubmit={handleSubmit} className="change-password-form">
        <label>
          Current Password
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </label>
        <label>
          New Password
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </label>
        <label>
          Confirm New Password
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
        {message && <div className="change-password-message">{message}</div>}
      </form>
    </div>
  );
};

export default ChangePassword;
